import { render } from "./TheThanhTichTongHopTheThaoVH2.vue?vue&type=template&id=44a4f4e4"
import script from "./TheThanhTichTongHopTheThaoVH2.vue?vue&type=script&lang=js"
export * from "./TheThanhTichTongHopTheThaoVH2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__